<template>
    <div class="button_container" :style="{ color: props.textColor, background: props.bgColor }" @click="handleOnClick">
        <!-- <img :src="props.icon" alt=""> -->
        <div class="btn_text">
            {{ props.text }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
    icon: {
        type: String,
        default: () => ''
    },
    text: {
        type: String,
        default: () => ''
    },
    textColor: {
        type: String,
        default: () => '#fff'
    },
    bgColor: {
        type: String,
        default: () => '#ffffff14'
    },
})
const emits = defineEmits(['onClick'])
const handleOnClick = () => {
    emits('onClick')
}

</script>
<style scoped>
.button_container {
    border-radius: 15px;
    font-size: 14px;
    padding: 15px;
    display: flex;
    justify-content: center;
}

.button_container img {
    width: 22px;
    margin-right: 5px;
}

.button_container>>>.van-button__content {
    justify-content: center !important;
}

.btn_text {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 16px;
}
</style>